import { render } from "./AdminTemplateFiles.vue?vue&type=template&id=0fd993b2"
import script from "./AdminTemplateFiles.vue?vue&type=script&lang=js"
export * from "./AdminTemplateFiles.vue?vue&type=script&lang=js"

import "./AdminTemplateFiles.vue?vue&type=style&index=0&id=0fd993b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__